import { useMemo, useState } from "react";
import { useAccountsStore } from "../../../stores/ConfigStore";
import MultiSelector from "../../../components/Selectors/MultiSelector";
import { Link } from "react-router-dom";
import { getTypeIcon } from "../workflows/CreateCampaign/flow/flowSettings";
import { getEmails, getLinkedinAccounts } from "../../../api/EmailAPI";
import { IconSend } from "@tabler/icons-react";
import { useReportingStore } from "../../../stores/ReportingStore";
import { Anchor } from "@mantine/core";
import { useLanguage } from "../../../stores/LanguageStore";

function getOptionName(option) {
  return `${option.name} #${option.id}`;
}

const AllAccountsSelector = () => {
  const lang = useLanguage(s => s.language)
  const integrations = useReportingStore((s) => s.integrations);
  const setIntegrations = useReportingStore((s) => s.setIntegrations);
  const linkedins = useAccountsStore((s) => s.linkedin_accounts);
  const emails = useAccountsStore((s) => s.email_accounts);

  const options = useMemo(() => {
    return [...linkedins, ...emails].map((item) => ({
      ...item,
      option_name: getOptionName(item),
    }));
  }, [emails, linkedins]);

  const [loading, setLoading] = useState(false);
  const handleLoad = () => {
    setLoading(true);
    getLinkedinAccounts().then(() => {
      getEmails().finally(() => setLoading(false));
    });
  };

  return (
    <MultiSelector
      options={options}
      onDropdownOpen={handleLoad}
      loading={loading}
      values={integrations}
      onChange={setIntegrations}
      placeholder={lang.reports.senders}
      leftSection={<IconSend size={18} />}
      leftOptionSection={(item) =>
        getTypeIcon(item.session_cookie ? "Linkedin" : item.account_type, false, 18, {
          variant: "subtle",
          size: "sm",
        })
      }
      rightOptionSection={(item) => {
        if (item.session_cookie) {
          return <Anchor size="xs" w={75} component={Link} to={`/senders/linkedin/${item.id}`}>#{item.id}</Anchor>;
        }
        return <Anchor size="xs" w={75} component={Link} to={`/senders/email/${item.id}`}>#{item.id}</Anchor>;
      }}
      size={"md"}
      w={"100%"}
      searchable
      checkIconPosition="left"
      dropdownHeight={200}
      withDropdown
      styles={{
        input: {
          borderColor: "var(--mantine-primary-color-0)",
        },
      }}
      autoFocus={false}
    />
  );
};

export default AllAccountsSelector;
